// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "5f0479f3cba29f1d10ab419a1129b65955e5ca54/static/css/" + chunkId + "." + "8ea9c403" + ".chunk.css";
};